import React from 'react';

const Policy = () => (
  <>
    {/* Top Divider */}
    <hr className="g-brd-gray-light-v4 my-0" />

    {/* Contact Blocks */}
    <section className="container g-pt-75 g-pb-45">
      <div className="row">
        <div className="col-md-4 g-mb-30">
          <div className="g-bg-purple text-center rounded g-pos-rel g-z-index-1 g-px-20 g-py-30">
            <span className="u-icon-v1 u-icon-size--xl g-color-white g-mb-10">
              <i className="icon-communication-009 u-line-icon-pro" />
            </span>
            <h3 className="h4 g-color-white mb-2">Contact Us</h3>
            <span className="d-block h5 g-color-white-opacity-0_7 mb-4">
              +1 (832) 246-5377
            </span>
            <a
              className="btn btn-md u-btn-white g-color-white g-bg-white-opacity-0_2 g-brd-white--hover g-color-purple--hover g-bg-white--hover g-rounded-25"
              href="tel:+18322465377"
            >
              Give a Call
            </a>
          </div>
        </div>

        <div className="col-md-4 g-mb-30">
          <div className="g-bg-teal text-center rounded g-pos-rel g-z-index-1 g-px-20 g-py-30">
            <span className="u-icon-v1 u-icon-size--xl g-color-white g-mb-10">
              <i className="icon-communication-062 u-line-icon-pro" />
            </span>
            <h3 className="h4 g-color-white mb-2">E-mail Us</h3>
            <span className="d-block h5 g-color-white-opacity-0_7 mb-4">
              bishopkjbrown@gmail.com
            </span>
            <a
              className="btn btn-md u-btn-white g-color-white g-bg-white-opacity-0_2 g-brd-white--hover g-color-teal--hover g-bg-white--hover g-rounded-25"
              href="mailto:bishopkjbrown@gmail.com"
            >
              Say Hello
            </a>
          </div>
        </div>

        <div className="col-md-4 g-mb-30">
          <div className="g-bg-blue text-center rounded g-pos-rel g-z-index-1 g-px-20 g-py-30">
            <span className="u-icon-v1 u-icon-size--xl g-color-white g-mb-10">
              <i className="icon-communication-058 u-line-icon-pro" />
            </span>
            <h3 className="h4 g-color-white mb-2">Support</h3>
            <span className="d-block h5 g-color-white-opacity-0_7 mb-4">
              Technical / Website Support
            </span>
            <a
              className="btn btn-md u-btn-white g-color-white g-bg-white-opacity-0_2 g-brd-white--hover g-color-blue--hover g-bg-white--hover g-rounded-25"
              href="mailto:bishopkjbrown@gmail.com"
            >
              Ask Us
            </a>
          </div>
        </div>
      </div>
    </section>

    <hr className="g-brd-gray-light-v4 my-0" />

    {/* Policy Section */}
    <section className="g-bg-gray-gradient-opacity-v1">
      <div className="container g-py-75">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="text-center g-mb-20">
              <div className="d-inline-block g-width-35 g-height-1 g-bg-primary mb-2" />
              <h2 className="g-color-black g-font-weight-600 mb-2">Our Policy</h2>
              <p className="lead g-width-60x--md mx-auto">
                How we use and protect your information
              </p>
            </div>

            <div
              id="accordion"
              className="u-accordion u-accordion-color-primary"
              role="tablist"
              aria-multiselectable="true"
            >
              {/* General Information */}
              <div className="card g-brd-none rounded g-mb-20">
                <div
                  id="accordion-heading-01"
                  className="g-pa-0"
                  role="tab"
                >
                  <h5 className="mb-0">
                    <a
                      className="d-flex justify-content-between u-shadow-v19 g-color-main g-text-underline--none--hover rounded g-px-30 g-py-20 collapsed"
                      href="#accordion-body-01"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      aria-expanded="false"
                      aria-controls="accordion-body-01"
                    >
                      General Information
                      <span className="u-accordion__control-icon g-color-primary">
                        <i className="fa fa-angle-down" />
                        <i className="fa fa-angle-up" />
                      </span>
                    </a>
                  </h5>
                </div>
                <div
                  id="accordion-body-01"
                  className="collapse"
                  role="tabpanel"
                  aria-labelledby="accordion-heading-01"
                  data-parent="#accordion"
                >
                  <div className="u-accordion__body g-color-gray-dark-v4 g-pa-30">
                    <p className="text-md-left g-font-size-12">
                      Bishop K.J. Brown Ministries is committed to respecting your
                      privacy. When you visit our website, submit a prayer request,
                      contact us, or partner with the ministry, we may collect basic
                      information such as your name, email address, phone number, and
                      any details you choose to share with us.
                    </p>
                    <p className="text-md-left g-font-size-12">
                      We use this information to respond to your requests, communicate
                      ministry updates, and provide resources that may be helpful to
                      you. We do not sell your personal information, and we strive to
                      handle all data in a way that honors both you and the Lord.
                    </p>
                  </div>
                </div>
              </div>

              {/* Rights & Choices */}
              <div className="card g-brd-none rounded g-mb-20">
                <div
                  id="accordion-heading-02"
                  className="g-pa-0"
                  role="tab"
                >
                  <h5 className="mb-0">
                    <a
                      className="collapsed d-flex justify-content-between u-shadow-v19 g-color-main g-text-underline--none--hover rounded g-px-30 g-py-20"
                      href="#accordion-body-02"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      aria-expanded="false"
                      aria-controls="accordion-body-02"
                    >
                      Your Rights and Choices
                      <span className="u-accordion__control-icon g-color-primary">
                        <i className="fa fa-angle-down" />
                        <i className="fa fa-angle-up" />
                      </span>
                    </a>
                  </h5>
                </div>
                <div
                  id="accordion-body-02"
                  className="collapse"
                  role="tabpanel"
                  aria-labelledby="accordion-heading-02"
                  data-parent="#accordion"
                >
                  <div className="u-accordion__body g-color-gray-dark-v4 g-pa-30">
                    <p className="text-md-left g-font-size-12">
                      You may request to review, update, or delete the personal
                      information we have about you by contacting us using the details
                      on this page. If you receive ministry emails or updates and no
                      longer wish to, you may unsubscribe using the link provided in
                      the email or by reaching out to us directly.
                    </p>
                    <p className="text-md-left g-font-size-12">
                      While we take reasonable steps to protect your information, no
                      website or communication over the internet can be guaranteed
                      100% secure. We encourage you to use wisdom when sharing
                      sensitive information online.
                    </p>
                  </div>
                </div>
              </div>

              {/* Management of Personal Data */}
              <div className="card g-brd-none rounded g-mb-20">
                <div
                  id="accordion-heading-03"
                  className="g-pa-0"
                  role="tab"
                >
                  <h5 className="mb-0">
                    <a
                      className="collapsed d-flex justify-content-between u-shadow-v19 g-color-main g-text-underline--none--hover rounded g-px-30 g-py-20"
                      href="#accordion-body-03"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      aria-expanded="false"
                      aria-controls="accordion-body-03"
                    >
                      Management of Personal Data
                      <span className="u-accordion__control-icon g-color-primary">
                        <i className="fa fa-angle-down" />
                        <i className="fa fa-angle-up" />
                      </span>
                    </a>
                  </h5>
                </div>
                <div
                  id="accordion-body-03"
                  className="collapse"
                  role="tabpanel"
                  aria-labelledby="accordion-heading-03"
                  data-parent="#accordion"
                >
                  <div className="u-accordion__body g-color-gray-dark-v4 g-pa-30">
                    <p className="text-md-left g-font-size-12">
                      We keep your personal data only for as long as it is needed for
                      ministry purposes—such as responding to your questions, praying
                      over your requests, maintaining giving records as required by
                      law, or sending you updates you have requested.
                    </p>
                    <p className="text-md-left g-font-size-12">
                      If you would like us to stop using your information for certain
                      purposes (for example, receiving email updates), please let us
                      know and we will do our best to honor your request while still
                      meeting any legal or accounting obligations we may have.
                    </p>
                  </div>
                </div>
              </div>

              {/* How We Use Your Information */}
              <div className="card g-brd-none rounded g-mb-20">
                <div
                  id="accordion-heading-05"
                  className="g-pa-0"
                  role="tab"
                >
                  <h5 className="mb-0">
                    <a
                      className="collapsed d-flex justify-content-between u-shadow-v19 g-color-main g-text-underline--none--hover rounded g-px-30 g-py-20"
                      href="#accordion-body-05"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      aria-expanded="false"
                      aria-controls="accordion-body-05"
                    >
                      How We Use Your Information
                      <span className="u-accordion__control-icon g-color-primary">
                        <i className="fa fa-angle-down" />
                        <i className="fa fa-angle-up" />
                      </span>
                    </a>
                  </h5>
                </div>
                <div
                  id="accordion-body-05"
                  className="collapse"
                  role="tabpanel"
                  aria-labelledby="accordion-heading-05"
                  data-parent="#accordion"
                >
                  <div className="u-accordion__body g-color-gray-dark-v4 g-pa-30">
                    <p className="text-md-left g-font-size-12">
                      We use the information we collect to:
                    </p>
                    <ul className="text-md-left g-font-size-12">
                      <li>Respond to your messages and prayer requests;</li>
                      <li>
                        Share ministry news, events, teachings, and resources (when
                        you choose to receive them);
                      </li>
                      <li>
                        Process and acknowledge donations through secure third-party
                        providers (such as Tithe.ly);
                      </li>
                      <li>
                        Improve our website and online communication so we can serve
                        you better.
                      </li>
                    </ul>
                    <p className="text-md-left g-font-size-12">
                      We strive to use your data in ways that are consistent with the
                      purpose for which it was given and in line with this policy.
                    </p>
                  </div>
                </div>
              </div>

              {/* Sharing Your Information */}
              <div className="card g-brd-none rounded g-mb-0">
                <div
                  id="accordion-heading-06"
                  className="g-pa-0"
                  role="tab"
                >
                  <h5 className="mb-0">
                    <a
                      className="collapsed d-flex justify-content-between u-shadow-v19 g-color-main g-text-underline--none--hover rounded g-px-30 g-py-20"
                      href="#accordion-body-06"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      aria-expanded="false"
                      aria-controls="accordion-body-06"
                    >
                      Sharing Your Information
                      <span className="u-accordion__control-icon g-color-primary">
                        <i className="fa fa-angle-down" />
                        <i className="fa fa-angle-up" />
                      </span>
                    </a>
                  </h5>
                </div>
                <div
                  id="accordion-body-06"
                  className="collapse"
                  role="tabpanel"
                  aria-labelledby="accordion-heading-06"
                  data-parent="#accordion"
                >
                  <div className="u-accordion__body g-color-gray-dark-v4 g-pa-30">
                    <p className="text-md-left g-font-size-12">
                      We do not sell or rent your personal information. We may share
                      your data with trusted service providers who help us operate the
                      ministry—for example, email providers, website hosting, and
                      secure payment processors. These partners are only permitted to
                      use your information to provide services on our behalf.
                    </p>
                    <p className="text-md-left g-font-size-12">
                      We may also disclose information if required by law, to comply
                      with a legal process, or to protect the rights, property, or
                      safety of Bishop K.J. Brown Ministries, our partners, or those
                      we serve.
                    </p>
                    <p className="text-md-left g-font-size-12 mb-0">
                      If this policy is updated in the future, we will post the
                      changes on this page so that you always know how your
                      information is being used.
                    </p>
                  </div>
                </div>
              </div>
              {/* End accordion */}
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default Policy;
